import { useFlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGet } from "../../vl-api/vlComponents";
import { useQueryClient } from "@tanstack/react-query";
import { getActiveQueryByOperationId } from "../../vl-api/vlUtils";
import { FlywheelDatasetStatus, FlywheelStatus } from "../../vl-api/vlSchemas";
import { useCallback } from "react";

export const useFlywheelStatus = (datasetId?: string) => {
  const { data } = useFlywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGet(
    {
      pathParams: { datasetId: datasetId! },
    },
    { enabled: Boolean(datasetId) },
  );

  return data?.flywheel_status || undefined;
};

export const useRefetchFlywheelStatus = () => {
  const queryClient = useQueryClient();
  return useCallback(
    (flywheelStatus: FlywheelStatus | undefined) => {
      const activeQuery = getActiveQueryByOperationId(
        queryClient,
        "flywheelDatasetCurrentStatusApiV1FlywheelDatasetIdGet",
      );
      if (activeQuery) {
        queryClient.setQueryData(
          activeQuery.queryKey,
          (data: FlywheelDatasetStatus) => ({
            ...data,
            flywheel_status: flywheelStatus,
          }),
        );
      }
    },
    [queryClient],
  );
};
